export default [
  [
    {
      id: 'bill',
      type: 5,
      span: 24,
      offset: 0,
      props: {
        padding: '8px 0', width: '100%', title: { text: 'ใบปะหน้า' },
      },
    }, {
      id: 'refId',
      type: 2,
      span: 4,
      offset: 0,
      props: {
        padding: '8px 0', width: '100%', title: { text: 'รหัส' },
      },
    }, {
      id: 'createdDate',
      type: 4,
      span: 4,
      offset: 12,
      dataType: 'date',
      props: { padding: '8px 0', width: '100%', title: { text: 'วันที่สร้าง *' } },
    }, {
      id: 'dueDate',
      type: 4,
      span: 4,
      dataType: 'date',
      props: { padding: '8px 0', width: '100%', title: { text: 'วันกำหนดชำระ *' } },
    },
  ], [
    {
      id: 'companyName',
      type: 2,
      span: 4,
      props: {
        padding: '8px 0', width: '100%', title: { text: 'ผู้จ้าง' },
      },
    }, {
      id: 'branch',
      type: 2,
      span: 4,
      props: { padding: '8px 0', width: '100%', title: { text: 'สาขา' } },
    }, {
      id: 'typeOfChargeName',
      type: 2,
      span: 4,
      props: { padding: '8px 0', width: '100%', title: { text: 'ประเภทผู้จ้าง' } },
    },
  ],
]
